import React from 'react'

interface GCalIconProps {
  width?: string | number
  height?: string | number
}

export const GCalIcon: React.FC<GCalIconProps> = ({
  width = '21',
  height = '21'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      role="img"
      aria-label="Google Calendar Icon"
    >
      <path
        d="M0.25 16.075H4.99359V5.43402H15.6346V0.69043H2.62179C1.0406 0.69043 0.25 1.43829 0.25 2.93402"
        fill="#4285F4"
      />
      <path
        d="M15.5063 0.69043V5.56222H20.2499V2.93402C20.2499 1.43829 19.5021 0.69043 18.0063 0.69043"
        fill="#1967D2"
      />
      <path d="M15.5063 5.43396H20.2499V15.9468H15.5063" fill="#FBBC04" />
      <path
        d="M0.25 15.9469V18.4469C0.25 19.9426 0.997863 20.6905 2.49359 20.6905H5.12179V15.9469"
        fill="#188038"
      />
      <path d="M4.99365 15.9469H15.5065V20.6905H4.99365" fill="#34A853" />
      <path d="M15.5063 20.6905V15.9469H20.2499" fill="#EA4335" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7767 7.42121L12.878 7.38916H13.1344V7.42121H13.6152V14.0238H12.6536V8.61569L11.4239 9.48105L10.8705 8.6947L12.6013 7.47675L12.6536 7.46019V7.42121H12.7767ZM8.85466 8.40723C8.64716 8.34437 8.4225 8.33375 8.20816 8.37713C7.99383 8.4205 7.80486 8.51472 7.66019 8.64215C7.51602 8.76913 7.42293 8.92239 7.3817 9.08078L6.45117 8.83857C6.54374 8.48293 6.74582 8.16618 7.02464 7.9206C7.30295 7.67545 7.6478 7.5095 8.01742 7.4347C8.38703 7.35989 8.77302 7.37781 9.13342 7.48698C9.49386 7.59617 9.82033 7.79423 10.0718 8.06583C10.3238 8.33801 10.4907 8.67395 10.5437 9.03759C10.5969 9.40179 10.5322 9.76952 10.3613 10.0966C10.2403 10.3285 10.0707 10.5311 9.86651 10.6959C10.0691 10.8613 10.2373 11.0638 10.3577 11.2947C10.5278 11.6213 10.5931 11.988 10.541 12.3513C10.4889 12.7142 10.3232 13.0493 10.0721 13.3205C9.82145 13.5912 9.49587 13.7878 9.13636 13.8957C8.7769 14.0035 8.39194 14.0201 8.02318 13.9448C7.65442 13.8694 7.31009 13.7037 7.03134 13.4598C6.75215 13.2155 6.5482 12.9007 6.45238 12.5469L7.38049 12.2955C7.42351 12.4544 7.51849 12.6084 7.6645 12.7362C7.81095 12.8643 8.00112 12.9589 8.21566 13.0027C8.43021 13.0466 8.65409 13.0365 8.86011 12.9747C9.06607 12.9129 9.24003 12.8038 9.36651 12.6672C9.49242 12.5313 9.56633 12.3739 9.58919 12.2147C9.61198 12.0559 9.58459 11.8919 9.50496 11.7391C9.42483 11.5853 9.29273 11.4454 9.11554 11.3417C8.93978 11.2388 8.73064 11.1784 8.51175 11.1712H7.94208V10.2097H8.51427C8.73448 10.205 8.94458 10.1462 9.12071 10.0447C9.29764 9.94272 9.42931 9.8042 9.50902 9.65155C9.58823 9.49986 9.61557 9.33605 9.59228 9.1764C9.56891 9.0162 9.49396 8.85701 9.36627 8.71911C9.23804 8.58062 9.06213 8.47007 8.85466 8.40723Z"
        fill="#4285F4"
      />
    </svg>
  )
}
